import React from "react"

const Saved = () => {
  return <div>SAVED</div>
}

export default Saved;
